<template>
  <div class="el-card pd20">
    <!-- 搜索---serch-box -->
    <div class="el-card pd20 search">
        <div class="search-box">
            <!-- 测评名称 -->
            <label >试用名称：</label>
            <el-input clear="input" v-model="searchName" placeholder="请输入试用名称"></el-input>
            
            <el-button type="primary" class="btn" @click="pullData" round size="small">查&nbsp;&nbsp;询</el-button>
            <el-button   @click="GenerateTrialLinks()" round size="small">生成试用链接</el-button>
        </div>
    </div>
    <div class="main">
      <div class="search-box"></div>
      <!-- list -->
      <div class="list-box">
        <el-table :data="list" show-overflow-tooltip border style="width: 100%">
          <el-table-column type="selection" width="55"></el-table-column>
          <el-table-column type="index" width="100" label="序号"></el-table-column>
          <el-table-column prop="name" label="试用名称"></el-table-column>
          <el-table-column  label="关联测评">
              <template slot-scope="scope">
                  <span v-if="scope.row.eid==item.id" v-for="(item,index) in measurement_list" :key="index">{{item.title}}</span>
              </template>
          </el-table-column>
          <el-table-column prop="count" label="总量"></el-table-column>
          <el-table-column prop="use_count" label="已使用"></el-table-column>
          <el-table-column label="操作" width="180">
              <template slot-scope="scope">
                  <el-button type="primary" size="mini"  @click="usageLogHandle(scope.$index, scope.row,'edit')" >使用记录</el-button>
                  <el-button type="danger" size="mini"  @click="failureHandle(scope.$index, scope.row)" >失效</el-button>
              </template>
          </el-table-column>
        </el-table>
      </div>
      <!-- 分页 -->
      <el-pagination class="pages" 
        :page-sizes="[25, 50, 75, 100]"
        @size-change="handleSizeChange" 
        @current-change="handleCurrentChange" 
        :page-size="pages.size" 
        :current-page="pages.page"
        background 
        layout="sizes,prev, pager, next" 
        :total="pages.count"> 
      </el-pagination>
    </div>
    <!-- 生成试用链接 -->
    <el-dialog  :visible.sync="generateLinksBool">
        <el-form :model="form">
            <el-form-item label="试用名称：" :label-width="formLabelWidth">
                <el-input v-model="form.name" autocomplete="off"></el-input>
            </el-form-item>
            <!--  -->
            <el-form-item label="关联测评：" :label-width="formLabelWidth">
                <el-select v-model="form.eid" placeholder="请选择关联测评">
                    <el-option v-for="(item,index) in measurement_list" :key="index"  :label="item.title" :value="item.id"></el-option>
                </el-select>
            </el-form-item>
            <!--  -->
            <el-form-item label="生成数量：" :label-width="formLabelWidth">
                <el-input type="number" v-model="form.count" autocomplete="off"></el-input>&nbsp;个
            </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button @click="generateLinksBool = false">取 消</el-button>
            <el-button type="primary" @click="addHandle()">确 定</el-button>
        </div>
    </el-dialog>
  </div>
</template>

<script>
import { groupList,cepingList,addGroup,disableGroup } from "@/api/measurement";

export default {
    data() {
        return{
            list: [],
            pages: {},
            searchName:'',
            generateLinksBool:false,
            formLabelWidth:'100px',
            form:{
                name:'',
                eid:'',
                count:null
            },
            measurement_list:[]
        }
    },
    methods:{
        /*
         *@param: 
         *@return: 
         *@Description: 使用记录
         *@MethodAuthor:  Zhang Xiao Guang
         *@Date: 2019-10-18 13:44:02
        */
        usageLogHandle(index,row){
            this.$router.push({
                path:'/main/evaluation_trial_details',
                query:{
                    group_id:row.id
                }
            });
        },
        /*
         *@param: 
         *@return: 
         *@Description: 确定要失效试用链接吗
         *@MethodAuthor:  Zhang Xiao Guang
         *@Date: 2019-10-18 13:26:26
        */
        failureHandle(index,row){
            this.$confirm('确认要失效吗?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                disableGroup({
                    group_id:row.id
                }).then((data)=>{
                    if(data.error >0){
                        this.$message(data.msg);
                        return false;
                    }
                    this.$notify({
                        title: '成功',
                        message: '试用链接已失效！',
                        type: 'success'
                    });
                });
            }).catch();
        },
        /*
         *@param: 
         *@return: 
         *@Description: 生成使用链接
         *@MethodAuthor:  Zhang Xiao Guang
         *@Date: 2019-10-18 10:56:12
        */
        GenerateTrialLinks(){
            this.generateLinksBool = true;
        },
        // 调整每页显示条数
        handleSizeChange(val) {
            this.pages.size = val;
            this.pullData();
        },
        // 触发分页
        handleCurrentChange(val) {
            this.pages.page = val;
            this.pullData();
        },
        /*
         *@param: 
         *@return: 
         *@Description: 生成测评试用链接
         *@MethodAuthor:  Zhang Xiao Guang
         *@Date: 2019-10-18 12:50:16
        */
        addHandle(){
            if(!this.form.name || !this.form.eid || !this.form.count){
                this.$message({
                    message: '试用信息不能为空哦！',
                    type: 'warning'
                });
                return false;
            }
            addGroup(this.form).then((data)=>{
                if(data.error >0){
                    this.$message(data.msg);
                    return false;
                }
                this.$notify({
                    title: '成功',
                    message: '生成试用链接成功！',
                    type: 'success'
                });
                this.generateLinksBool = false;
                this.pullData();
            });
            
        },
        
        // 初始化获取数据
        pullData(){
            this.$showLoading();
            let obj = {
                page:this.pages?this.pages.page:null,  //页码，默认1
                size:this.pages?this.pages.size:null,   //每页数量，默认25
            };
            if(this.searchName !=''){
                obj['name'] = this.searchName;
            }
            let gl =  groupList(obj);
            // 请求测评列表接口
            let cl = cepingList();
            Promise.all([gl,cl]).then((data)=>{
                this.list = data[0].list;
                this.pages = data[0].pager;
                
                // 测评列表
                this.measurement_list = data[1].list;
                this.$hideLoading();
            }).catch((err)=>{
                this.$hideLoading();
            });
        }
    },
    created(){
        this.pullData();
    }
    
}
</script>

<style lang="scss" scoped>
.main{
  position: relative;
}
.addBtn{
  position: absolute;
  left: 0;
  bottom: 0;
}
.pages{
  text-align: right;
  margin-top: 30px;
}
.search{
    margin-bottom: 20px;
    .search-box{
        display: flex;
        align-items: center;
        label{
            font-size: 16px;
            color: #606266;
        }
        .on{
            margin: 0 80px;
        }
        .input{
            width: 500px;
        }
        .btn{
            margin-left: auto;
        }
    }
    
}
</style>
<style lang="scss">
.search-box{
    .el-input{
        width: 500px;
    }
}
</style>
